import type { HistoricAncPrescription } from "$routes/patient/[:patientId]/antenatal-care/_lib/anc-encounters";

export const getPrescriptionLabel = (
  prescription: HistoricAncPrescription,
): string => {
  return prescription.clinicalProduct?.title ?? "";
};

const AncPrescriptionLabel: FC<{
  prescription: HistoricAncPrescription;
}> = ({ prescription }) => {
  return <>{getPrescriptionLabel(prescription)}</>;
};

export default AncPrescriptionLabel;
